import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'

const DeleteUsersFromListConfirmationModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.deleteUsersFromListConfirmationModalVisible}
        onClose={distributeStore.hideDeleteUsersFromListConfirmationModal}
    >
        <div style={{ textAlign: 'center' }}>
            <Typography type="h2">{i18n.t('deleteUsersModal.title')}</Typography>

            <br />

            <Typography>
                {
                    i18n.t('deleteUsersConfirmationModal.subtitle',
                        { records: distributeStore.usersToDeleteCount, list: R.pathOr('', ['listToDelete', 'listname'], distributeStore) })
                }
            </Typography>

            <br />

            <Typography type="tiny">{i18n.t('deleteUsersConfirmationModal.tiny')}</Typography>
        </div>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
                label={i18n.t('cancel')}
                onClick={distributeStore.hideDeleteUsersFromListConfirmationModal}
                cssClass="regular tertiary"
            />

            <Button
                label={i18n.t('deleteUsersConfirmationModal.confirm')}
                onClick={distributeStore.confirmDeleteUsersFromList}
                icon="fal fa-circle-xmark"
                cssClass="regular error"
            />
        </div>
    </Modal>
)

export default observer(DeleteUsersFromListConfirmationModal)
